<div class="ap-margin-bottom-3">{{ 'property.sustainability-loan.button-group' | coApplicantPipe: store.hasCoApplicant | apContent }}</div>

<ap-button-group id="sustainabilityButton" [formControl]="mainApplicantControl" (buttonGroupClicked)="onButtonGroupClicked($event)">
    <ap-button-group-item label="{{ 'general.button-group.yes' | apContent }}" value="true"> </ap-button-group-item>
    <ap-button-group-item label="{{ 'general.button-group.no' | apContent }}" value="false"> </ap-button-group-item>
</ap-button-group>

<additional-info
    [key]="questionKey"
    titleKey="property.sustainability-loan.button-group.additional-info.text"
    contentKey="property.sustainability-loan.button-group.additional-info.content"
    modalUrlKey="property.sustainability-loan.button-group.additional-info.text"
></additional-info>
